// Auto-generated blocklist — do not render on HTML pages
const blockedWordsEn = [
  "abbo",
  "abeed",
  "abuse",
  "acrotomophilia",
  "aeolus",
  "africoon",
  "ahole",
  "alligatorbait",
  "amcik",
  "anal",
  "analannie",
  "analprobe",
  "analsex",
  "andskota",
  "anilingus",
  "anus",
  "apeshit",
  "arabush",
  "arabushs",
  "areola",
  "areole",
  "argie",
  "armo",
  "armos",
  "aroused",
  "arrse",
  "arschloch",
  "arse",
  "arsehole",
  "aryan",
  "asholes",
  "ass",
  "assbag",
  "assbagger",
  "assbandit",
  "assbang",
  "assbanged",
  "assbanger",
  "assbangs",
  "assbite",
  "assblaster",
  "assclown",
  "asscock",
  "asscowboy",
  "asscracker",
  "asses",
  "assface",
  "assfuck",
  "assfucker",
  "assfukka",
  "assgoblin",
  "asshat",
  "asshead",
  "asshole",
  "assholes",
  "assholz",
  "asshopper",
  "asshore",
  "assjacker",
  "assjockey",
  "asskiss",
  "asskisser",
  "assklown",
  "asslick",
  "asslicker",
  "asslover",
  "assman",
  "assmaster",
  "assmonkey",
  "assmunch",
  "assmuncher",
  "assnigger",
  "asspacker",
  "asspirate",
  "asspuppies",
  "assrammer",
  "assranger",
  "assshit",
  "assshole",
  "asssucker",
  "asswad",
  "asswhole",
  "asswhore",
  "asswipe",
  "asswipes",
  "autoerotic",
  "axwound",
  "ayir",
  "azazel",
  "azz",
  "azzhole",
  "babeland",
  "babes",
  "backdoor",
  "backdoorman",
  "badfuck",
  "bagging",
  "ballbag",
  "balllicker",
  "balls",
  "ballsack",
  "bampot",
  "bangbro",
  "bangbros",
  "bangbus",
  "banger",
  "banging",
  "bareback",
  "barelylegal",
  "barenaked",
  "barf",
  "barface",
  "barfface",
  "bassterd",
  "bassterds",
  "bastard",
  "bastardo",
  "bastards",
  "bastardz",
  "basterds",
  "basterdz",
  "bastinado",
  "bawdy",
  "bazongas",
  "bazooms",
  "bbw",
  "bch",
  "bdsm",
  "beaner",
  "beaners",
  "beaney",
  "beaneys",
  "beardedclam",
  "beastality",
  "beastial",
  "beastiality",
  "beastility",
  "beatch",
  "beatoff",
  "beatyourmeat",
  "beeyotch",
  "bellend",
  "beotch",
  "bestial",
  "bestiality",
  "biatch",
  "bich",
  "bicurious",
  "bigass",
  "bigbastard",
  "bigbreasts",
  "bigbutt",
  "bigtits",
  "bimbo",
  "bimbos",
  "bint",
  "birdlock",
  "bitch",
  "bitchass",
  "bitched",
  "bitcher",
  "bitchers",
  "bitches",
  "bitchez",
  "bitchin",
  "bitching",
  "bitchslap",
  "bitchtit",
  "bitchtits",
  "bitchy",
  "biteme",
  "bitties",
  "blackcock",
  "blackman",
  "blackout",
  "blacks",
  "bloodclaat",
  "bloody",
  "blowjob",
  "blowjobs",
  "bluegum",
  "bluegums",
  "blumpkin",
  "boang",
  "boche",
  "boches",
  "bodily",
  "boffing",
  "bogan",
  "bohunk",
  "boink",
  "boiolas",
  "bollick",
  "bollock",
  "bollocks",
  "bollok",
  "bollox",
  "bombers",
  "bombing",
  "bomd",
  "bondage",
  "boned",
  "boner",
  "boners",
  "bong",
  "boob",
  "boobie",
  "boobs",
  "bookie",
  "boong",
  "boonga",
  "boongas",
  "boongs",
  "boonie",
  "boonies",
  "booobs",
  "boooobs",
  "booooobs",
  "booooooobs",
  "bootee",
  "bootlip",
  "bootlips",
  "boozer",
  "boozy",
  "bosch",
  "bosche",
  "bosches",
  "boschs",
  "bosomy",
  "bountybar",
  "breastjob",
  "breastlover",
  "breastman",
  "breasts",
  "brotherfucker",
  "btch",
  "buceta",
  "buddhahead",
  "buddhaheads",
  "buffies",
  "bugger",
  "buggered",
  "buggery",
  "bukake",
  "bukkake",
  "bullcrap",
  "bulldike",
  "bulldyke",
  "bullshit",
  "bullshits",
  "bullshitted",
  "bullturds",
  "bum",
  "bumblefuck",
  "bumfuck",
  "bung",
  "bunga",
  "bungas",
  "bunghole",
  "burrhead",
  "burrheads",
  "busty",
  "butchbabes",
  "butchdike",
  "butchdyke",
  "butt",
  "buttbang",
  "buttcheeks",
  "buttface",
  "buttfuck",
  "buttfucka",
  "buttfucker",
  "buttfuckers",
  "butthead",
  "butthole",
  "buttman",
  "buttmuch",
  "buttmunch",
  "buttmuncher",
  "buttpirate",
  "buttplug",
  "buttstain",
  "buttwipe",
  "byatch",
  "cabron",
  "caca",
  "cacker",
  "cahone",
  "cameljockey",
  "cameltoe",
  "camgirl",
  "camslut",
  "camwhore",
  "carpetmuncher",
  "carruth",
  "cawk",
  "cawks",
  "cazzo",
  "cervix",
  "chav",
  "cheesehead",
  "cheeseheads",
  "cherrypopper",
  "chesticle",
  "chickslick",
  "chinaman",
  "chinamen",
  "chinaswede",
  "chinaswedes",
  "chinc",
  "chincs",
  "chinga",
  "chingchong",
  "chingchongs",
  "chink",
  "chinks",
  "chinky",
  "choad",
  "chode",
  "chodes",
  "chonkies",
  "chonky",
  "chonkys",
  "chraa",
  "chug",
  "chugs",
  "chuj",
  "chunger",
  "chungers",
  "chunkies",
  "chunkys",
  "chute",
  "cialis",
  "cipa",
  "circlejerk",
  "clamdigger",
  "clamdiver",
  "clamps",
  "clansman",
  "clansmen",
  "clanswoman",
  "clanswomen",
  "clit",
  "clitface",
  "clitfuck",
  "clitoris",
  "clitorus",
  "clits",
  "clitty",
  "clogwog",
  "clusterfuck",
  "cnts",
  "cntz",
  "cnut",
  "cocain",
  "cocaine",
  "cock",
  "cockass",
  "cockbite",
  "cockblock",
  "cockblocker",
  "cockburger",
  "cockcowboy",
  "cockface",
  "cockfight",
  "cockfucker",
  "cockhead",
  "cockholster",
  "cockjockey",
  "cockknob",
  "cockknocker",
  "cockknoker",
  "cocklicker",
  "cocklover",
  "cockmaster",
  "cockmongler",
  "cockmongruel",
  "cockmonkey",
  "cockmunch",
  "cockmuncher",
  "cocknob",
  "cocknose",
  "cocknugget",
  "cockqueen",
  "cockrider",
  "cocks",
  "cockshit",
  "cocksman",
  "cocksmith",
  "cocksmoke",
  "cocksmoker",
  "cocksniffer",
  "cocksucer",
  "cocksuck",
  "cocksucked",
  "cocksucker",
  "cocksucking",
  "cocksucks",
  "cocksuka",
  "cocksukka",
  "cocktease",
  "cockwaffle",
  "cocky",
  "cohee",
  "coital",
  "coitus",
  "cok",
  "cokmuncher",
  "coksucka",
  "commie",
  "condom",
  "coochie",
  "coochy",
  "coolie",
  "coolies",
  "cooly",
  "coon",
  "coonass",
  "coonasses",
  "coondog",
  "coons",
  "cooter",
  "coprolagnia",
  "coprophilia",
  "copulate",
  "corksucker",
  "cornhole",
  "cox",
  "crabs",
  "crackcocain",
  "cracker",
  "crackpipe",
  "crackwhore",
  "crap",
  "crapola",
  "crapper",
  "crappy",
  "creampie",
  "crotch",
  "crotchjockey",
  "crotchmonkey",
  "crotchrot",
  "cuck",
  "cum",
  "cumbubble",
  "cumdumpster",
  "cumfest",
  "cumguzzler",
  "cuming",
  "cumjockey",
  "cumlickr",
  "cumm",
  "cummer",
  "cummin",
  "cumming",
  "cumquat",
  "cumqueen",
  "cums",
  "cumshot",
  "cumshots",
  "cumslut",
  "cumstain",
  "cumsucker",
  "cumtart",
  "cunilingus",
  "cunillingus",
  "cunn",
  "cunnie",
  "cunnilingus",
  "cunntt",
  "cunny",
  "cunt",
  "cuntass",
  "cunteyed",
  "cuntface",
  "cuntfuck",
  "cuntfucker",
  "cunthole",
  "cunthunter",
  "cuntlick",
  "cuntlicker",
  "cuntlicking",
  "cuntrag",
  "cunts",
  "cuntslut",
  "cuntsucker",
  "cuntz",
  "currymuncher",
  "currymunchers",
  "cushi",
  "cushis",
  "cyalis",
  "cyberfuc",
  "cyberfuck",
  "cyberfucked",
  "cyberfucker",
  "cyberfuckers",
  "cyberfucking",
  "cybersex",
  "cyberslimer",
  "dago",
  "dagos",
  "dahmer",
  "damm",
  "dammit",
  "damn",
  "damnation",
  "damned",
  "damnit",
  "darkey",
  "darkeys",
  "darkie",
  "darkies",
  "darky",
  "daterape",
  "datnigga",
  "daygo",
  "deapthroat",
  "deepaction",
  "deepthroat",
  "deepthroating",
  "defecate",
  "deggo",
  "dego",
  "degos",
  "demon",
  "dendrophilia",
  "destroyyourpussy",
  "deth",
  "diaperdaddy",
  "diaperhead",
  "diaperheads",
  "dick",
  "dickbag",
  "dickbeater",
  "dickbeaters",
  "dickbrain",
  "dickdipper",
  "dickface",
  "dickflipper",
  "dickforbrains",
  "dickfuck",
  "dickfucker",
  "dickhead",
  "dickheads",
  "dickhole",
  "dickish",
  "dickjuice",
  "dickless",
  "dicklick",
  "dicklicker",
  "dickman",
  "dickmilk",
  "dickmonger",
  "dickpic",
  "dickripper",
  "dicks",
  "dicksipper",
  "dickslap",
  "dickslicker",
  "dicksucker",
  "dicksucking",
  "dicktickler",
  "dickwad",
  "dickweasel",
  "dickweed",
  "dickwhipper",
  "dickwod",
  "dickzipper",
  "diddle",
  "dike",
  "dildo",
  "dildos",
  "dilf",
  "diligaf",
  "dillweed",
  "dimwit",
  "dingle",
  "dingleberries",
  "dingleberry",
  "dink",
  "dinks",
  "dipship",
  "dipshit",
  "dipstick",
  "dirsa",
  "dix",
  "dixiedike",
  "dixiedyke",
  "dlck",
  "doggie",
  "doggiestyle",
  "doggin",
  "dogging",
  "doggystyle",
  "dolcett",
  "domination",
  "dominatricks",
  "dominatrics",
  "dominatrix",
  "dommes",
  "dong",
  "donkeypunch",
  "donkeyribber",
  "doochbag",
  "doodoo",
  "doofus",
  "dookie",
  "doosh",
  "dothead",
  "dotheads",
  "doubledong",
  "doublepenetration",
  "douche",
  "douchebag",
  "douchebags",
  "douchewaffle",
  "douchey",
  "dpaction",
  "dragqueen",
  "dragqween",
  "dripdick",
  "dryhump",
  "duche",
  "dudette",
  "dumass",
  "dumbass",
  "dumbasses",
  "dumbbitch",
  "dumbfuck",
  "dumbshit",
  "dumshit",
  "dupa",
  "dvda",
  "dyefly",
  "dyke",
  "dykes",
  "dziwka",
  "earotics",
  "easyslut",
  "eatadick",
  "eatballs",
  "eathairpie",
  "eatme",
  "eatmyass",
  "eatpussy",
  "ecchi",
  "ejackulate",
  "ejaculate",
  "ejaculated",
  "ejaculates",
  "ejaculating",
  "ejaculatings",
  "ejaculation",
  "ejakulate",
  "ekrem",
  "ekto",
  "enculer",
  "enema",
  "enlargement",
  "erect",
  "erection",
  "ero",
  "erotic",
  "erotism",
  "escort",
  "esqua",
  "essohbee",
  "eunuch",
  "evl",
  "excrement",
  "exkwew",
  "extacy",
  "extasy",
  "facefucker",
  "fack",
  "faeces",
  "faen",
  "fag",
  "fagbag",
  "faget",
  "fagfucker",
  "fagg",
  "fagged",
  "fagging",
  "faggit",
  "faggitt",
  "faggot",
  "faggotcock",
  "faggs",
  "fagit",
  "fagot",
  "fagots",
  "fags",
  "fagt",
  "fagtard",
  "fagz",
  "faig",
  "faigs",
  "faigt",
  "fanculo",
  "fanny",
  "fannybandit",
  "fannyflaps",
  "fannyfucker",
  "fanyy",
  "fart",
  "farted",
  "farting",
  "fartknocker",
  "farty",
  "fastfuck",
  "fatah",
  "fatass",
  "fatfuck",
  "fatfucker",
  "fatso",
  "fck",
  "fckcum",
  "fckd",
  "fcuk",
  "fcuker",
  "fcuking",
  "fecal",
  "feces",
  "feck",
  "fecker",
  "feg",
  "felatio",
  "felch",
  "felcher",
  "felching",
  "fellate",
  "fellatio",
  "feltch",
  "feltcher",
  "feltching",
  "femalesquirtin",
  "femalesquirting",
  "femdom",
  "fetish",
  "ficken",
  "figging",
  "fingerbang",
  "fingerfood",
  "fingerfuck",
  "fingerfucked",
  "fingerfucker",
  "fingerfuckers",
  "fingerfucking",
  "fingerfucks",
  "fingering",
  "fisted",
  "fister",
  "fistfuck",
  "fistfucked",
  "fistfucker",
  "fistfuckers",
  "fistfucking",
  "fistfuckings",
  "fistfucks",
  "fisting",
  "fisty",
  "fitt",
  "flamer",
  "flange",
  "flasher",
  "flikker",
  "flipping",
  "flogthelog",
  "floo",
  "floozy",
  "flydie",
  "flydye",
  "foad",
  "fok",
  "fondle",
  "foobar",
  "fook",
  "fooker",
  "footaction",
  "footfetish",
  "footfuck",
  "footfucker",
  "footjob",
  "footlicker",
  "footstar",
  "foreskin",
  "forni",
  "fornicate",
  "fotze",
  "foursome",
  "fourtwenty",
  "freakfuck",
  "freakyfucker",
  "freefuck",
  "freex",
  "frigg",
  "frigga",
  "frigger",
  "frotting",
  "fucck",
  "fuchah",
  "fuck",
  "fucka",
  "fuckable",
  "fuckass",
  "fuckbag",
  "fuckbitch",
  "fuckbook",
  "fuckboy",
  "fuckbrain",
  "fuckbuddy",
  "fuckbutt",
  "fuckbutter",
  "fuckd",
  "fucked",
  "fuckedup",
  "fucker",
  "fuckers",
  "fuckersucker",
  "fuckface",
  "fuckfest",
  "fuckfreak",
  "fuckfriend",
  "fuckhead",
  "fuckheads",
  "fuckher",
  "fuckhole",
  "fuckin",
  "fuckina",
  "fucking",
  "fuckingbitch",
  "fuckings",
  "fuckingshitmotherfucker",
  "fuckinnuts",
  "fuckinright",
  "fuckit",
  "fuckknob",
  "fuckme",
  "fuckmeat",
  "fuckmehard",
  "fuckmonkey",
  "fuckn",
  "fucknugget",
  "fucknut",
  "fucknuts",
  "fucknutt",
  "fucknutz",
  "fuckoff",
  "fuckpig",
  "fuckpuppet",
  "fuckr",
  "fucks",
  "fuckstick",
  "fucktard",
  "fucktards",
  "fucktart",
  "fucktoy",
  "fucktrophy",
  "fuckup",
  "fuckwad",
  "fuckwhit",
  "fuckwhore",
  "fuckwit",
  "fuckwitt",
  "fuckyomama",
  "fuckyou",
  "fudgepacker",
  "fugly",
  "fuk",
  "fukah",
  "fuken",
  "fuker",
  "fukin",
  "fuking",
  "fukk",
  "fukka",
  "fukkah",
  "fukken",
  "fukker",
  "fukkin",
  "fukking",
  "fuks",
  "fuktard",
  "fuktards",
  "fukwhit",
  "fukwit",
  "funfuck",
  "fungus",
  "futanari",
  "futanary",
  "futkretzn",
  "fuuck",
  "fux",
  "fuxor",
  "fvck",
  "fvk",
  "fxck",
  "gae",
  "gai",
  "gangbang",
  "gangbanged",
  "gangbanger",
  "gangbangs",
  "gangsta",
  "ganja",
  "gassyass",
  "gatorbait",
  "gay",
  "gayass",
  "gaybob",
  "gaybor",
  "gayboy",
  "gaydo",
  "gayfuck",
  "gayfuckist",
  "gaygirl",
  "gaylord",
  "gaymuthafuckinwhore",
  "gays",
  "gaysex",
  "gaytard",
  "gaywad",
  "gayz",
  "geezer",
  "geni",
  "genital",
  "genitals",
  "getiton",
  "gey",
  "gfy",
  "ghay",
  "ghey",
  "gigolo",
  "ginzo",
  "ginzos",
  "gipp",
  "gippo",
  "gippos",
  "gipps",
  "givehead",
  "glans",
  "glazeddonut",
  "goatcx",
  "goatse",
  "gob",
  "godam",
  "godammit",
  "godamn",
  "godamnit",
  "goddam",
  "goddamit",
  "goddamm",
  "goddammit",
  "goddamn",
  "goddamned",
  "goddamnes",
  "goddamnit",
  "goddamnmuthafucker",
  "godsdamn",
  "gokkun",
  "goldenshower",
  "golliwog",
  "golliwogs",
  "gonad",
  "gonads",
  "gonorrehea",
  "gonzagas",
  "gooch",
  "goodpoop",
  "gook",
  "gookeye",
  "gookeyes",
  "gookies",
  "gooks",
  "gooky",
  "gora",
  "goras",
  "goregasm",
  "gotohell",
  "goy",
  "goyim",
  "greaseball",
  "greaseballs",
  "gringo",
  "groe",
  "groid",
  "groids",
  "grope",
  "grostulation",
  "gspot",
  "gstring",
  "gtfo",
  "gub",
  "gubba",
  "gubbas",
  "gubs",
  "guido",
  "guiena",
  "guineas",
  "guizi",
  "gummer",
  "guro",
  "gwailo",
  "gwailos",
  "gweilo",
  "gweilos",
  "gyopo",
  "gyopos",
  "gyp",
  "gyped",
  "gypo",
  "gypos",
  "gypp",
  "gypped",
  "gyppie",
  "gyppies",
  "gyppo",
  "gyppos",
  "gyppy",
  "gyppys",
  "gypsys",
  "hadji",
  "hadjis",
  "hairyback",
  "hairybacks",
  "haji",
  "hajis",
  "hajji",
  "hajjis",
  "halfbreed",
  "halfcaste",
  "hamas",
  "hamflap",
  "handjob",
  "haole",
  "haoles",
  "hapa",
  "hardcore",
  "hardcoresex",
  "hardon",
  "harem",
  "headfuck",
  "hebe",
  "hebes",
  "heeb",
  "heebs",
  "hell",
  "hells",
  "helvete",
  "hentai",
  "heroin",
  "herp",
  "herpes",
  "herpy",
  "heshe",
  "hijacker",
  "hijacking",
  "hillbillies",
  "hillbilly",
  "hindoo",
  "hiscock",
  "hitler",
  "hitlerism",
  "hitlerist",
  "ho",
  "hoar",
  "hoare",
  "hobag",
  "hodgie",
  "hoe",
  "hoer",
  "hoes",
  "holestuffer",
  "homey",
  "homo",
  "homobangers",
  "homodumbshit",
  "homoerotic",
  "homoey",
  "honger",
  "honkers",
  "honkey",
  "honkeys",
  "honkie",
  "honkies",
  "honky",
  "hooch",
  "hooker",
  "hookers",
  "hoor",
  "hoore",
  "hootch",
  "hooter",
  "hooters",
  "hore",
  "hori",
  "horis",
  "hork",
  "horndawg",
  "horndog",
  "horney",
  "horniest",
  "horny",
  "horseshit",
  "hosejob",
  "hoser",
  "hotcarl",
  "hotdamn",
  "hotpussy",
  "hotsex",
  "hottotrot",
  "howtokill",
  "howtomurdep",
  "huevon",
  "hugefat",
  "hui",
  "hummer",
  "humped",
  "humper",
  "humpher",
  "humphim",
  "humpin",
  "humping",
  "hussy",
  "hustler",
  "hymen",
  "hymie",
  "hymies",
  "iblowu",
  "ike",
  "ikes",
  "ikey",
  "ikeymo",
  "ikeymos",
  "ikwe",
  "illegal",
  "illegals",
  "inbred",
  "incest",
  "indon",
  "indons",
  "injun",
  "injuns",
  "insest",
  "intercourse",
  "interracial",
  "intheass",
  "inthebuff",
  "israels",
  "jackass",
  "jackhole",
  "jackoff",
  "jackshit",
  "jacktheripper",
  "jagoff",
  "jailbait",
  "jap",
  "japcrap",
  "japie",
  "japies",
  "japs",
  "jebus",
  "jerk",
  "jerkass",
  "jerked",
  "jerkoff",
  "jerries",
  "jerry",
  "jewboy",
  "jewed",
  "jewess",
  "jiga",
  "jigaboo",
  "jigaboos",
  "jigarooni",
  "jigaroonis",
  "jigg",
  "jigga",
  "jiggabo",
  "jiggaboo",
  "jiggabos",
  "jiggas",
  "jigger",
  "jiggerboo",
  "jiggers",
  "jiggs",
  "jiggy",
  "jigs",
  "jihad",
  "jijjiboo",
  "jijjiboos",
  "jimfish",
  "jisim",
  "jism",
  "jiss",
  "jiz",
  "jizim",
  "jizin",
  "jizjuice",
  "jizm",
  "jizn",
  "jizz",
  "jizzd",
  "jizzed",
  "jizzim",
  "jizzin",
  "jizzn",
  "jizzum",
  "jugg",
  "juggs",
  "jugs",
  "junglebunny",
  "junkie",
  "junky",
  "kacap",
  "kacapas",
  "kacaps",
  "kaffer",
  "kaffir",
  "kaffre",
  "kafir",
  "kanake",
  "kanker",
  "katsap",
  "katsaps",
  "kawk",
  "khokhol",
  "khokhols",
  "kicking",
  "kigger",
  "kike",
  "kikes",
  "kimchis",
  "kinbaku",
  "kink",
  "kinkster",
  "kinky",
  "kinkyjesus",
  "kissass",
  "kiunt",
  "kkk",
  "klan",
  "klansman",
  "klansmen",
  "klanswoman",
  "klanswomen",
  "klootzak",
  "knob",
  "knobbing",
  "knobead",
  "knobed",
  "knobend",
  "knobhead",
  "knobjocky",
  "knobjokey",
  "knobs",
  "knobz",
  "knockers",
  "knulle",
  "kock",
  "kondum",
  "kondums",
  "kooch",
  "kooches",
  "koon",
  "kootch",
  "krap",
  "krappy",
  "kraut",
  "krauts",
  "kuffar",
  "kuk",
  "kuksuger",
  "kum",
  "kumbubble",
  "kumbullbe",
  "kumer",
  "kummer",
  "kumming",
  "kumquat",
  "kums",
  "kunilingus",
  "kunnilingus",
  "kunt",
  "kunts",
  "kuntz",
  "kurac",
  "kurwa",
  "kushi",
  "kushis",
  "kusi",
  "kwa",
  "kwif",
  "kyke",
  "kykes",
  "kyopo",
  "kyopos",
  "kyrpa",
  "labia",
  "lameass",
  "lapdance",
  "lardass",
  "leatherrestraint",
  "lebos",
  "lech",
  "lemonparty",
  "leper",
  "lesbain",
  "lesbayn",
  "lesbian",
  "lesbin",
  "lesbo",
  "lesbos",
  "lez",
  "lezbe",
  "lezbefriends",
  "lezbian",
  "lezbians",
  "lezbo",
  "lezbos",
  "lezz",
  "lezzian",
  "lezzie",
  "lezzies",
  "lezzo",
  "lezzy",
  "libido",
  "licker",
  "licking",
  "lickme",
  "lilniglet",
  "limey",
  "limpdick",
  "limy",
  "lingerie",
  "lipshits",
  "lipshitz",
  "livesex",
  "lmfao",
  "loadedgun",
  "loin",
  "loins",
  "lolita",
  "lovebone",
  "lovegoo",
  "lovegun",
  "lovejuice",
  "lovemaking",
  "lovemuscle",
  "lovepistol",
  "loverocket",
  "lowlife",
  "lsd",
  "lubejob",
  "lubra",
  "lucifer",
  "luckycammeltoe",
  "lugan",
  "lugans",
  "lust",
  "lusting",
  "lusty",
  "lynch",
  "mabuno",
  "mabunos",
  "macaca",
  "macacas",
  "mafugly",
  "magicwand",
  "mahbuno",
  "mahbunos",
  "makemecome",
  "makemecum",
  "mamhoon",
  "mams",
  "manhater",
  "manpaste",
  "maricon",
  "maricón",
  "marijuana",
  "masochist",
  "masokist",
  "massa",
  "massterbait",
  "masstrbait",
  "masstrbate",
  "mastabate",
  "mastabater",
  "masterbaiter",
  "masterbat",
  "masterbate",
  "masterbates",
  "masterbating",
  "masterbation",
  "masterbations",
  "masterblaster",
  "mastrabator",
  "masturbat",
  "masturbate",
  "masturbating",
  "masturbation",
  "mattressprincess",
  "maumau",
  "maumaus",
  "mcfagget",
  "meatbeatter",
  "meatrack",
  "menage",
  "merd",
  "mgger",
  "mggor",
  "mibun",
  "mick",
  "mickeyfinn",
  "mideast",
  "mierda",
  "milf",
  "minge",
  "minger",
  "mockey",
  "mockie",
  "mocky",
  "mofo",
  "moky",
  "molest",
  "molestation",
  "molester",
  "molestor",
  "moneyshot",
  "mong",
  "monkleigh",
  "moolie",
  "mooncricket",
  "mooncrickets",
  "mormon",
  "moron",
  "moskal",
  "moskals",
  "moslem",
  "mosshead",
  "motha",
  "mothafuck",
  "mothafucka",
  "mothafuckas",
  "mothafuckaz",
  "mothafucked",
  "mothafucker",
  "mothafuckers",
  "mothafuckin",
  "mothafuckin'",
  "mothafucking",
  "mothafuckings",
  "mothafucks",
  "mothafuker",
  "mothafukkah",
  "mothafukker",
  "motherfuck",
  "motherfucka",
  "motherfucked",
  "motherfucker",
  "motherfuckers",
  "motherfuckin",
  "motherfucking",
  "motherfuckings",
  "motherfuckka",
  "motherfucks",
  "motherfukah",
  "motherfuker",
  "motherfukkah",
  "motherfukker",
  "motherfvcker",
  "motherlovebone",
  "mothrfucker",
  "mouliewop",
  "moundofvenus",
  "mrhands",
  "mtherfucker",
  "mthrfuck",
  "mthrfucker",
  "mthrfucking",
  "mtrfck",
  "mtrfuck",
  "mtrfucker",
  "muff",
  "muffdive",
  "muffdiver",
  "muffdiving",
  "muffindiver",
  "mufflikcer",
  "muffpuff",
  "muie",
  "mulatto",
  "mulkku",
  "muncher",
  "mung",
  "munging",
  "munt",
  "munter",
  "muschi",
  "mutha",
  "muthafecker",
  "muthafuckaz",
  "muthafucker",
  "muthafuckker",
  "muthafukah",
  "muthafuker",
  "muthafukkah",
  "muthafukker",
  "muther",
  "mutherfucker",
  "mutherfucking",
  "muthrfucking",
  "mzungu",
  "mzungus",
  "nad",
  "nads",
  "naked",
  "nambla",
  "nappy",
  "nastt",
  "nasty",
  "nastybitch",
  "nastyho",
  "nastyslut",
  "nastywhore",
  "nawashi",
  "nazi",
  "nazis",
  "nazism",
  "necked",
  "necro",
  "needthedick",
  "negres",
  "negress",
  "negro",
  "negroes",
  "negroid",
  "negros",
  "neonazi",
  "nepesaurio",
  "nig",
  "niga",
  "nigaboo",
  "nigar",
  "nigars",
  "nigas",
  "nigers",
  "nigette",
  "nigettes",
  "nigg",
  "nigga",
  "niggah",
  "niggahs",
  "niggar",
  "niggaracci",
  "niggard",
  "niggarded",
  "niggarding",
  "niggardliness",
  "niggardlinesss",
  "niggardly",
  "niggards",
  "niggars",
  "niggas",
  "niggaz",
  "nigger",
  "niggerhead",
  "niggerhole",
  "niggers",
  "niggle",
  "niggled",
  "niggles",
  "niggling",
  "nigglings",
  "niggor",
  "niggress",
  "niggresses",
  "nigguh",
  "nigguhs",
  "niggur",
  "niggurs",
  "niglet",
  "nignog",
  "nigor",
  "nigors",
  "nigr",
  "nigra",
  "nigras",
  "nigre",
  "nigres",
  "nigress",
  "nigs",
  "nigur",
  "niiger",
  "niigr",
  "nimphomania",
  "nimrod",
  "ninny",
  "nip",
  "nipple",
  "nipplering",
  "nipples",
  "nips",
  "nittit",
  "nlgger",
  "nlggor",
  "nob",
  "nobhead",
  "nobjocky",
  "nobjokey",
  "nofuckingway",
  "nog",
  "nookey",
  "nookie",
  "nooky",
  "noonan",
  "nooner",
  "nsfw",
  "nude",
  "nudger",
  "nudie",
  "nudies",
  "nudity",
  "numbnuts",
  "nutbutter",
  "nutfucker",
  "nutsack",
  "nutten",
  "nymph",
  "nympho",
  "nymphomania",
  "octopussy",
  "omorashi",
  "ontherag",
  "orafis",
  "orally",
  "orga",
  "orgasim",
  "orgasim;",
  "orgasims",
  "orgasm",
  "orgasmic",
  "orgasms",
  "orgasum",
  "orgies",
  "orgy",
  "oriface",
  "orifice",
  "orifiss",
  "orospu",
  "osama",
  "ovum",
  "ovums",
  "packi",
  "packie",
  "packy",
  "paddy",
  "paedophile",
  "paki",
  "pakie",
  "pakis",
  "paky",
  "palesimian",
  "panooch",
  "pansies",
  "pansy",
  "panti",
  "pantie",
  "panties",
  "panty",
  "paska",
  "pastie",
  "pasty",
  "pawn",
  "payo",
  "pcp",
  "pearlnecklace",
  "pecker",
  "peckerhead",
  "peckerwood",
  "pedo",
  "pedobear",
  "pedophile",
  "pedophilia",
  "pedophiliac",
  "peeenus",
  "peeenusss",
  "peehole",
  "peenus",
  "peepee",
  "peepshow",
  "peepshpw",
  "pegging",
  "peinus",
  "penas",
  "pendejo",
  "pendy",
  "penetrate",
  "penetration",
  "penial",
  "penile",
  "penis",
  "penisbanger",
  "penisbreath",
  "penises",
  "penisfucker",
  "penisland",
  "penislick",
  "penislicker",
  "penispuffer",
  "penthouse",
  "penus",
  "penuus",
  "perse",
  "perv",
  "perversion",
  "peyote",
  "phalli",
  "phallic",
  "phonesex",
  "phuc",
  "phuck",
  "phuk",
  "phuked",
  "phuker",
  "phuking",
  "phukked",
  "phukker",
  "phukking",
  "phuks",
  "phungky",
  "phuq",
  "picaninny",
  "piccaninny",
  "picka",
  "pickaninnies",
  "pickaninny",
  "pieceofshit",
  "piefke",
  "piefkes",
  "pierdol",
  "pigfucker",
  "piker",
  "pikey",
  "piky",
  "pillowbiter",
  "pillu",
  "pimmel",
  "pimp",
  "pimped",
  "pimper",
  "pimpis",
  "pimpjuic",
  "pimpjuice",
  "pimpsimp",
  "pindick",
  "pinko",
  "pis",
  "pises",
  "pisin",
  "pising",
  "pisof",
  "piss",
  "pissed",
  "pisser",
  "pissers",
  "pisses",
  "pissflap",
  "pissflaps",
  "pisshead",
  "pissin",
  "pissing",
  "pissoff",
  "pisspig",
  "pistol",
  "pizda",
  "playboy",
  "playgirl",
  "pleasurechest",
  "pocha",
  "pochas",
  "pocho",
  "pochos",
  "pocketpool",
  "pohm",
  "pohms",
  "polac",
  "polack",
  "polacks",
  "polak",
  "polesmoker",
  "pollock",
  "pollocks",
  "pommy",
  "ponyplay",
  "poo",
  "poof",
  "poon",
  "poonani",
  "poonany",
  "poontang",
  "poontsee",
  "poop",
  "poopchute",
  "pooper",
  "pooperscooper",
  "pooping",
  "poorwhitetrash",
  "popimp",
  "porchmonkey",
  "porn",
  "pornflick",
  "pornking",
  "porno",
  "pornography",
  "pornos",
  "pornprincess",
  "poundtown",
  "pplicker",
  "premature",
  "preteen",
  "pric",
  "prick",
  "prickhead",
  "pricks",
  "prig",
  "pron",
  "prostitute",
  "pthc",
  "pube",
  "pubes",
  "pubic",
  "pubiclice",
  "pubis",
  "pud",
  "pudboy",
  "pudd",
  "puddboy",
  "puke",
  "pula",
  "pule",
  "punani",
  "punanny",
  "punany",
  "punkass",
  "punky",
  "punta",
  "puntang",
  "purinapricness",
  "pusies",
  "puss",
  "pusse",
  "pussee",
  "pussi",
  "pussie",
  "pussies",
  "pussy",
  "pussycat",
  "pussydestroyer",
  "pussyeater",
  "pussyfart",
  "pussyfucker",
  "pussylicker",
  "pussylicking",
  "pussylips",
  "pussylover",
  "pussypalace",
  "pussypounder",
  "pussys",
  "pusy",
  "puta",
  "puto",
  "puuke",
  "puuker",
  "qahbeh",
  "quashie",
  "queaf",
  "queef",
  "queer",
  "queerbait",
  "queerhole",
  "queero",
  "queers",
  "queerz",
  "quickie",
  "quicky",
  "quiff",
  "quim",
  "qweers",
  "qweerz",
  "qweir",
  "raghead",
  "ragheads",
  "rape",
  "raped",
  "raper",
  "raping",
  "rapist",
  "rautenberg",
  "rearend",
  "rearentry",
  "recktum",
  "rectal",
  "rectum",
  "rectus",
  "redleg",
  "redlegs",
  "redlight",
  "redneck",
  "rednecks",
  "redskin",
  "redskins",
  "reefer",
  "reestie",
  "reetard",
  "reich",
  "renob",
  "rentafuck",
  "rere",
  "retard",
  "retarded",
  "retards",
  "retardz",
  "reversecowgirl",
  "rigger",
  "rimjaw",
  "rimjob",
  "rimming",
  "ritard",
  "rosebuds",
  "rosypalm",
  "rosypalmandherefivesisters",
  "roundeye",
  "rtard",
  "rtards",
  "rumprammer",
  "ruski",
  "russki",
  "russkie",
  "rustytrombone",
  "sac",
  "sadis",
  "sadism",
  "sadist",
  "sadom",
  "sambo",
  "sambos",
  "samckdaddy",
  "sanchez",
  "sandm",
  "sandnigger",
  "santorum",
  "sausagequeen",
  "scag",
  "scallywag",
  "scank",
  "scantily",
  "scat",
  "schaffer",
  "scheiss",
  "schizo",
  "schlampe",
  "schlong",
  "schmuck",
  "schvartse",
  "schvartsen",
  "schwartze",
  "schwartzen",
  "scissoring",
  "screw",
  "screwed",
  "screwing",
  "screwyou",
  "scroat",
  "scrog",
  "scrote",
  "scrotum",
  "scrud",
  "seduce",
  "semen",
  "seppo",
  "seppos",
  "septics",
  "sex",
  "sexcam",
  "sexed",
  "sexfarm",
  "sexhound",
  "sexhouse",
  "sexi",
  "sexing",
  "sexkitten",
  "sexo",
  "sexpot",
  "sexslave",
  "sextogo",
  "sextoy",
  "sextoys",
  "sexual",
  "sexuality",
  "sexually",
  "sexwhore",
  "sexx",
  "sexxi",
  "sexxx",
  "sexxxi",
  "sexxxy",
  "sexxy",
  "sexy",
  "sexymoma",
  "sexyslim",
  "shag",
  "shagger",
  "shaggin",
  "shagging",
  "shamedame",
  "sharmuta",
  "sharmute",
  "shat",
  "shav",
  "shavedbeaver",
  "shavedpussy",
  "shawtypimp",
  "sheeney",
  "shemale",
  "shhit",
  "shibari",
  "shibary",
  "shinola",
  "shipal",
  "shit",
  "shitass",
  "shitbag",
  "shitbagger",
  "shitblimp",
  "shitbrain",
  "shitbrains",
  "shitbreath",
  "shitcan",
  "shitcanned",
  "shitcunt",
  "shitdick",
  "shite",
  "shiteater",
  "shiteating",
  "shited",
  "shitey",
  "shitface",
  "shitfaced",
  "shitfit",
  "shitforbrains",
  "shitfuck",
  "shitfucker",
  "shitfull",
  "shithapens",
  "shithappens",
  "shithead",
  "shitheel",
  "shithole",
  "shithouse",
  "shiting",
  "shitings",
  "shitlist",
  "shitload",
  "shitola",
  "shitoutofluck",
  "shitpot",
  "shits",
  "shitspitter",
  "shitstain",
  "shitt",
  "shitted",
  "shitter",
  "shitters",
  "shittiest",
  "shitting",
  "shittings",
  "shitty",
  "shity",
  "shitz",
  "shiz",
  "shiznit",
  "shortfuck",
  "shota",
  "shrimping",
  "shylock",
  "shylocks",
  "shyt",
  "shyte",
  "shytty",
  "shyty",
  "simp",
  "sissy",
  "sixsixsix",
  "sixtynine",
  "sixtyniner",
  "skag",
  "skanck",
  "skank",
  "skankbitch",
  "skankee",
  "skankey",
  "skankfuck",
  "skanks",
  "skankwhore",
  "skanky",
  "skankybitch",
  "skankywhore",
  "skeet",
  "skinflute",
  "skrib",
  "skribz",
  "skullfuck",
  "skum",
  "skumbag",
  "skurwysyn",
  "skwa",
  "skwe",
  "slag",
  "slanteye",
  "slanty",
  "slapper",
  "sleezeball",
  "slideitin",
  "slimeball",
  "slimebucket",
  "slopehead",
  "slopeheads",
  "sloper",
  "slopers",
  "slopes",
  "slopey",
  "slopeys",
  "slopies",
  "slopy",
  "slut",
  "slutbag",
  "slutbucket",
  "slutdumper",
  "slutkiss",
  "sluts",
  "slutt",
  "slutting",
  "slutty",
  "slutwear",
  "slutwhore",
  "slutz",
  "smack",
  "smackthemonkey",
  "smeg",
  "smegma",
  "smoker",
  "smut",
  "smutty",
  "snatch",
  "snatchpatch",
  "snigger",
  "sniggered",
  "sniggering",
  "sniggers",
  "snowback",
  "snowballing",
  "snownigger",
  "snuff",
  "socksucker",
  "sodom",
  "sodomise",
  "sodomite",
  "sodomize",
  "sodomy",
  "sonofabitch",
  "sonofbitch",
  "sooties",
  "sooty",
  "souse",
  "soused",
  "soyboy",
  "spac",
  "spade",
  "spades",
  "spaghettibender",
  "spaghettinigger",
  "spank",
  "spankthemonkey",
  "spastic",
  "spearchucker",
  "spearchuckers",
  "sperm",
  "spermacide",
  "spermbag",
  "spermhearder",
  "spermherder",
  "sphencter",
  "spic",
  "spick",
  "spicks",
  "spics",
  "spierdalaj",
  "spig",
  "spigotty",
  "spik",
  "spiks",
  "spitter",
  "splittail",
  "splooge",
  "spludge",
  "spooge",
  "spook",
  "spreadeagle",
  "spunk",
  "spunky",
  "sqeh",
  "squa",
  "squarehead",
  "squareheads",
  "squaw",
  "squinty",
  "squirting",
  "stagg",
  "steamy",
  "stfu",
  "stiffy",
  "stoned",
  "stoner",
  "strapon",
  "strappado",
  "stringer",
  "stripclub",
  "stroke",
  "stroking",
  "stuinties",
  "stupidfuck",
  "stupidfucker",
  "suck",
  "suckass",
  "suckdick",
  "sucked",
  "sucker",
  "sucking",
  "suckme",
  "suckmyass",
  "suckmydick",
  "suckmytit",
  "suckoff",
  "sucks",
  "suicidegirl",
  "suicidegirls",
  "suka",
  "sultrywoman",
  "sultrywomen",
  "sumofabiatch",
  "swallower",
  "swalow",
  "swastika",
  "swinger",
  "sx",
  "syphilis",
  "taboo",
  "tacohead",
  "tacoheads",
  "taff",
  "tarbaby",
  "tard",
  "tastemy",
  "tawdry",
  "teabagging",
  "teat",
  "teets",
  "teez",
  "terd",
  "terror",
  "terrorist",
  "teste",
  "testee",
  "testes",
  "testical",
  "testicle",
  "testicles",
  "testis",
  "thicklip",
  "thicklips",
  "thirdeye",
  "thirdleg",
  "threesome",
  "threeway",
  "throating",
  "thumbzilla",
  "thundercunt",
  "timbernigger",
  "tinkle",
  "tit",
  "titbitnipply",
  "titfuck",
  "titfucker",
  "titfuckin",
  "titi",
  "titjob",
  "titlicker",
  "titlover",
  "tits",
  "titt",
  "tittie",
  "tittiefucker",
  "titties",
  "tittis",
  "titty",
  "tittyfuck",
  "tittyfucker",
  "tittys",
  "tittywank",
  "titwank",
  "tity",
  "toke",
  "tongethruster",
  "tongueina",
  "tonguethrust",
  "tonguetramp",
  "toots",
  "topless",
  "tortur",
  "torture",
  "tosser",
  "towelhead",
  "trailertrash",
  "tramp",
  "trannie",
  "tranny",
  "transsexual",
  "transvestite",
  "trashy",
  "tribadism",
  "triplex",
  "trisexual",
  "trois",
  "trojan",
  "trots",
  "tubgirl",
  "tuckahoe",
  "tunneloflove",
  "turd",
  "turnon",
  "tush",
  "tushy",
  "twat",
  "twathead",
  "twatlips",
  "twats",
  "twatty",
  "twatwaffle",
  "twink",
  "twinkie",
  "twobitwhore",
  "twunt",
  "twunter",
  "ukrop",
  "unclefucker",
  "undressing",
  "unfuckable",
  "upskirt",
  "uptheass",
  "upthebutt",
  "urethraplay",
  "urophilia",
  "usama",
  "ussys",
  "uzi",
  "vag",
  "vagiina",
  "vagina",
  "vajayjay",
  "vajina",
  "valium",
  "vgra",
  "viagra",
  "vibr",
  "vibrater",
  "vibrator",
  "vigra",
  "virgin",
  "virginbreaker",
  "vittu",
  "vixen",
  "vjayjay",
  "vodka",
  "vomit",
  "vorarephilia",
  "voyeur",
  "voyeurweb",
  "voyuer",
  "vullva",
  "vulva",
  "wab",
  "wad",
  "wang",
  "wank",
  "wanker",
  "wanking",
  "wankjob",
  "wanky",
  "waysted",
  "wazoo",
  "weenie",
  "weewee",
  "weiner",
  "welcher",
  "wench",
  "wetb",
  "wetback",
  "wetbacks",
  "wetdream",
  "wetspot",
  "whacker",
  "whash",
  "whigger",
  "whiggers",
  "whiskeydick",
  "whiskydick",
  "whit",
  "whitenigger",
  "whitepower",
  "whites",
  "whitetrash",
  "whitey",
  "whiteys",
  "whities",
  "whoar",
  "whop",
  "whoralicious",
  "whore",
  "whorealicious",
  "whorebag",
  "whored",
  "whoreface",
  "whorefucker",
  "whorehopper",
  "whorehouse",
  "whores",
  "whoring",
  "wichser",
  "wigga",
  "wiggas",
  "wigger",
  "wiggers",
  "willie",
  "willies",
  "williewanker",
  "willy",
  "wog",
  "wogs",
  "woose",
  "wop",
  "words",
  "worldsex",
  "wtf",
  "wuss",
  "wuzzie",
  "xkwe",
  "xrated",
  "xtc",
  "xx",
  "xxx",
  "xxxxxx",
  "yank",
  "yaoi",
  "yarpie",
  "yarpies",
  "yeasty",
  "yed",
  "yellowman",
  "yellowshowers",
  "yid",
  "yids",
  "yiffy",
  "yobbo",
  "yourboobs",
  "yourpenis",
  "yourtits",
  "yury",
  "zabourah",
  "zigabo",
  "zigabos",
  "zipperhead",
  "zipperheads",
  "zoophile",
  "zoophilia"
];

export default blockedWordsEn;
